import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import NewSongModal from './new-song-modal';
import SongList from './song-list';

@inject('songsStore', 'artistStore')
@observer
class Music extends React.Component {
	render () {
		const { songsStore, optionsTheme } = this.props;

		if (songsStore.isLoading) {

			return <h1>Loading...</h1>;
		}

		return (
			<div onClick={ this.onClick }>
				<div className="grid-x align-bottom">
					<div className="cell small-12">
						<NewSongModal />
					</div>
				</div>
				<div className="grid-x">
					<div className="cell small-12">
						<h2 className="subheader">Full Previews</h2>
					</div>
					<div className="cell small-12 full-preview-list">
						<SongList listKey="fullPreviewList" optionsTheme={ optionsTheme } />
					</div>
				</div>
				<div className="grid-x">
					<div className="cell">&nbsp;</div>
				</div>
				<div className="grid-x">
					<div className="cell small-12">
						<h2 className="subheader">Tracks</h2>
					</div>
					<div className="cell small-12">
						<SongList listKey="tracksList" optionsTheme={ optionsTheme } />
					</div>
				</div>
			</div>
		);
	}

	@autobind
	onClick ({ target: { classList } }) {
		if (classList.contains('button') || classList.contains('delete-button-container')) {

			return;
		}

		const { songsStore } = this.props;
		songsStore.activeSongRowID = null;
	}
}

export default Music;
